/* eslint-disable react/style-prop-object */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { Form, RadioGroup } from 'react-form';
import AddPhoto from '../PhotoUpload/AddPhoto';
import { getClubTierTypeDisplay, isTournamentClub, isPersonalClub } from '../../utils/clubs';
import { required } from '../../utils/validation';
import { removeNonPrintableCharacters } from '../../utils/misc';

import {
    Input,
    Textarea,
    RadioButton,
} from '../Form';

import styles from './form.scss';
import PlayerSearch from '../Form/PlayerSearch';

class CreateClubForm extends Component {
    constructor(props) {
        super(props);

        this.handlePlayerSelect = this.handlePlayerSelect.bind(this);
    }

    handlePlayerSelect(player, index) {
        console.log('handlePlayerSelect', player, index);
        const members = [...this.props.members];
        if (typeof player === 'object') {
            members[index] = player;
        } else if (typeof player === 'string') {
            members[index] = {
                email: player,
            };
        }
        console.log('members', members);
        this.props.setMembers(members);
    }

    render() {
        const {
            handleSubmit,
            submitting,
            handleUploadPhoto,
            handleUploadLogoStart,
            firstName,
        } = this.props;

        const defaultValues = this.props.defaultValues || {
            clubName: '',
            about: '',
            website: '',
            private: false,
            sponsorLogoUrl: null,
            tierType: {
                id: 1,
                name: 'Personal',
            },
        };

        if (defaultValues.tierType && defaultValues.tierType.id === 1 && !defaultValues.clubName) {
            defaultValues.clubName = `${firstName}'s Group`;
        }

        const isEditing = defaultValues.id;

        const isEmpty = value => value === undefined || value === null || value === '';

        const url = (value) => {
            let error;
            if (!isEmpty(value)) {
                // eslint-disable-next-line
                const newCheckUrl = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm.test(value.trim());
                if (!newCheckUrl) {
                    error = 'This does not appear to be a valid url';
                }
            }
            return error;
        };

        const onKeyPress = (event) => {
            if (event.key === 'Enter' && event.target.type !== 'submit' && event.target.type !== 'button' && event.target.id !== 'about') {
                event.preventDefault();
            }
        };

        return (
            <Form onSubmit={values => handleSubmit({ values })} defaultValues={defaultValues}>
                {({ submitForm, setValue }) => {
                    return (
                        <form onSubmit={submitForm} id="createClubForm" onKeyPress={onKeyPress}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-3">
                                        {
                                            isPersonalClub(defaultValues.tierType) ? <h5 className={`text-uppercase`}>Players Group Name</h5> : null
                                        }
                                    </div>
                                    <div className={`col-md-6 ${isPersonalClub(defaultValues.tierType) ? 'mt56' : ''}`}>
                                        <Input
                                            label="Name"
                                            id="clubName"
                                            field="clubName"
                                            type="text"
                                            placeholder={isPersonalClub(defaultValues.tierType) ? `${firstName}'s Group` : 'Ex. Palo Alto Tennis Group'}
                                            validate={required}
                                            disabled={isEditing}
                                            onChange={(e) => {
                                                setValue('clubName', removeNonPrintableCharacters(e));
                                            }}
                                        />
                                        <Textarea
                                            label="About (Optional)"
                                            description="Give a short description of your group that will appear on your players group page."
                                            id="about"
                                            field="about"
                                            rows="5"
                                            placeholder="Ex. Lorem ispum..."
                                        />
                                        {!isPersonalClub(defaultValues.tierType) && (
                                            <Input
                                                label="Website"
                                                description={`If your ${getClubTierTypeDisplay((defaultValues.tierType && defaultValues.tierType.name), true)} has its own website, you can link to it on your profile page.`}
                                                id="website"
                                                field="website"
                                                type="text"
                                                placeholder="https://example.com"
                                                validate={url}
                                            />
                                        )}
                                        {(!defaultValues.clubHasSchool &&
                                            (!isTournamentClub(defaultValues.tierType)) && !isPersonalClub(defaultValues.tierType)) && (
                                            <div className="form-group form-group-xl">
                                                <label>Public / Private</label>
                                                <small className="mb16">
                                                    If you select private, only members can view the members list on the profile page. You can change this at any point of time.
                                                </small>
                                                <RadioGroup field="private">
                                                    <RadioButton
                                                        key={0}
                                                        label="Public"
                                                        value={false}
                                                        id={`private${0}`}
                                                    />
                                                    <RadioButton
                                                        key={1}
                                                        label="Private"
                                                        value={true}
                                                        id={`private${1}`}
                                                    />
                                                </RadioGroup>
                                            </div>
                                        )}
                                        {isEditing && defaultValues.isPro && !defaultValues.sponsorLogoUrl && (
                                            <div className={`form-group`}>
                                                <label>Club Sponsorship</label>
                                                <div className="mb16">
                                                    <small>Display your sponsor’s logo on your club profile.</small>
                                                </div>
                                                <AddPhoto
                                                    maxSize={180}
                                                    uploadPhoto={handleUploadPhoto}
                                                    uploadStart={handleUploadLogoStart}
                                                    text={'Upload'}
                                                    style={3}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {
                                isPersonalClub(defaultValues.tierType) && !isEditing && (
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <h5 className={`text-uppercase`}>Invite Players</h5>
                                            </div>
                                            <div className={`col-md-6 ${isPersonalClub(defaultValues.tierType) ? 'mt56' : ''}`}>
                                                <React.Fragment>
                                                    {this.props.members.map((member, i) => {
                                                        return (
                                                            <React.Fragment>
                                                                <div className="row">
                                                                    <div className="col-11">
                                                                        <PlayerSearch
                                                                            index={i}
                                                                            className="form-control"
                                                                            emailTextInput={true}
                                                                            closeAfterSelect={true}
                                                                            handlePlayerSelect={this.handlePlayerSelect}
                                                                            value={member.displayName || member.email}
                                                                            placeholder="Search by name or invite by email"
                                                                            searchMembersOnly={true}
                                                                            allowQueryToBeSetToEmpty={true}
                                                                        />
                                                                    </div>
                                                                    <div className="col-1 close-wrapper">
                                                                        <div
                                                                            className="d-inline-block mt32 clickable"
                                                                            onClick={() => {
                                                                                const membersToInvite = [...this.props.members];
                                                                                membersToInvite.splice(i, 1);
                                                                                this.props.setMembers(membersToInvite);
                                                                            }}
                                                                        >
                                                                            <img src="/img/icons/close-icon-lg.svg" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                    <div className={`${styles.addAnotherContainer}`}>
                                                        <span
                                                            className={`${styles.addAnother}`}
                                                            onClick={() => {
                                                                const members = [...this.props.members, {
                                                                    id: this.props.members.length + 1,
                                                                    email: '',
                                                                }];
                                                                this.props.setMembers(members);
                                                            }}
                                                        >
                                                            Add Another
                                                        </span>
                                                    </div>
                                                </React.Fragment>
                                            </div>
                                        </div>
                                    </div>
                                )
}

                            <div className="container buttons">
                                <div className="row">
                                    <div className="col-md-6 offset-md-3">
                                        <div className="row">
                                            <div className="col-md-6 mb16">
                                                <button
                                                    onClick={() => {
                                                        if (isEditing) {
                                                            window.location.href = this.props.profileRedirectPath;
                                                        } else {
                                                            window.location.href = `/clubs`;
                                                        }
                                                    }}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="col-md-6 mb16">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    disabled={submitting}
                                                >
                                                    {submitting
                                                        ? (isEditing ? 'Updating...' : 'Creating...')
                                                        : (isEditing ? 'Update' : `Create${isPersonalClub(defaultValues.tierType) ? ' Group' : ''}`)}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    );
                }}
            </Form>
        );
    }
}

CreateClubForm.defaultProps = {
    profileRedirectPath: '/clubs',
};

export default CreateClubForm;
